<template>
  <el-dialog
    title="数据明细"
    :visible.sync="dialogVisible"
    width="75%"
    :before-close="handleClose">
    <div class="content">
      <el-card shadow="never">
        <div class="card-header" slot="header">
          <span>{{tradeData.merName}}</span>
          <i class="el-icon-time"></i>
          <span class="time">{{ timeRange[0] }} 至 {{ timeRange[1] }}</span>
        </div>
        <div class="card-content">
          <div class="card-content-item">
            <div class="amount">
              <span class="amount-num">{{ tradeData.tradeAmount | decimal }}</span>
              <span class="amount-unit">元</span>
            </div>
            <div class="label">交易总金额</div>
          </div>
          <div class="card-content-item">
            <div class="amount">
              <span class="amount-num">{{ tradeData.tradeCount }}</span>
              <span class="amount-unit">笔</span>
            </div>
            <div class="label">交易总笔数</div>
          </div>
          <div class="card-content-item">
            <div class="amount">
              <span class="amount-num">{{ tradeData.finshAmount | decimal }}</span>
              <span class="amount-unit">元</span>
            </div>
            <div class="label">已结算总金额</div>
          </div>
          <div class="card-content-item">
            <div class="amount">
              <span class="amount-num">{{ tradeData.finshCount }}</span>
              <span class="amount-unit">笔</span>
            </div>
            <div class="label">已结算总笔数</div>
          </div>
        </div>
      </el-card>
      <el-table class="mt-15" :data="tradeData.statisticDetailList">
        <el-table-column
          label="交易类型">
          <template slot-scope="scope">
            {{ typeMaps[scope.row.orderType] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tradeAmount"
          label="交易总金额(元)">
          <template slot-scope="scope">
            ￥{{scope.row.tradeAmount | decimal}}
          </template>
        </el-table-column>
        <el-table-column
          prop="tradeCount"
          label="交易总笔数(笔)">
        </el-table-column>
        <el-table-column
          label="结算总金额(元)">
          <template slot-scope="scope">
            ￥{{scope.row.settleAmount | decimal}}
          </template>
        </el-table-column>
        <el-table-column
          prop="settleCount"
          label="结算总笔数(笔)">
        </el-table-column>
        <el-table-column
          label="储值宝交易金额(元)">
          <template slot-scope="scope">
            ￥{{scope.row.tradeBalancePay | decimal}}
          </template>
        </el-table-column>
        <el-table-column
          label="代金券交易金额(元)">
          <template slot-scope="scope">
            ￥{{scope.row.tradeVoucherPay | decimal}}
          </template>
        </el-table-column>
        <el-table-column
          label="在线支付交易金额(元)">
          <template slot-scope="scope">
            ￥{{scope.row.tradeOtherPay | decimal}}
          </template>
        </el-table-column>
        <el-table-column
          label="储值宝已结算金额(元)">
          <template slot-scope="scope">
            ￥{{scope.row.settleBalancePay | decimal}}
          </template>
        </el-table-column>
        <el-table-column
          label="代金券已结算金额(元)">
          <template slot-scope="scope">
            ￥{{scope.row.settleVoucherPay | decimal}}
          </template>
        </el-table-column>
        <el-table-column
          label="在线支付已结算金额(元)">
          <template slot-scope="scope">
            ￥{{scope.row.settleOtherPay | decimal}}
          </template>
        </el-table-column>
        <el-table-column
          label="交易服务费(元)">
          <template slot-scope="scope">
            ￥{{scope.row.settleFee | decimal}}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'myInviteFlowDetail',
  data() {
    return {
      dialogVisible: false,
      tradeData: '',
      timeRange: [],
      typeMaps: {
        1: '实体交易',
        2: '虚拟交易',
        3: '服务交易',
        4: '线下交易'
      }
    }
  },
  methods: {
    show (flowData) {
      this.tradeData = flowData.data;
      this.timeRange = flowData.time;
      this.dialogVisible = true;
    },
    hide () {
      this.tradeData = '';
      this.timeRange = [];
    },
    handleClose (done) {
      this.tradeData = '';
      this.timeRange = [];
      done();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
/deep/ .el-card__header{
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.card-header{
  padding: 10px;
}
.card-content{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .card-content-item{
    flex: 1;
    text-align: center;
    .amount-num{
      font-size: 30px;
    }
    .label{
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/myInvite/myInviteFlowDetail.vue